var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalBedAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46967 6.46967C1.76256 6.17678 2.23744 6.17678 2.53033 6.46967L5.31066 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H18.7586L14.1055 14.3916L17.9665 17.2874C18.2681 17.105 18.6218 17 19 17C20.1046 17 21 17.8954 21 19C21 20.1046 20.1046 21 19 21C18.1607 21 17.4421 20.483 17.1454 19.75H8.85462C8.55793 20.483 7.83934 21 7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C7.36351 17 7.70438 17.097 7.99813 17.2665L11.6392 14.4169L6.75 10.75H5C4.80109 10.75 4.61032 10.671 4.46967 10.5303L1.46967 7.53033C1.17678 7.23744 1.17678 6.76256 1.46967 6.46967ZM9.17526 18.25H16.75L12.882 15.349L9.17526 18.25ZM9.25 10.75L12.8626 13.4595L16.3247 10.75H9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBedAlt);
export default __webpack_public_path__ + "static/media/hospital-bed-alt.47ba68c6ff0cc5a8d5da7c9cc2b697df.svg";
export { ForwardRef as ReactComponent };